import React from "react";
import { ColDef } from "ag-grid-community";
import { Box, Flex } from "@mantine/core";
import { VSpace } from "../../../../components";
import { AgGridReact } from "ag-grid-react";
import { IArkDeviceCompare } from "./nrhRoomValTypes";

const ArkSingleRoomValidationTable: React.FC<{ devices: IArkDeviceCompare[] }> = ({ devices }) => {
  const columns: ColDef<IArkDeviceCompare>[] = [
    {
      field: "compCode",
      headerName: "CompCode",
    },
    {
      field: "typeName",
      headerName: "Beskrivelse",
      width: 600,
    },
    {
      field: "quantityInDrofus",
      headerName: "Antall i dRofus",
    },
    {
      field: "quantityInInstance",
      headerName: "Antall i modell (rom)",
      cellRenderer: (params) => {
        return (
          <span>
            {params.data.quantityInDrofus !== params.value && (
              <i className="fa fa-exclamation-triangle fa-fw icon-warning" />
            )}
            {params.data.quantityInDrofus === params.value && <i className="fa fa-check fa-fw icon-success" />}
            {params.value}
          </span>
        );
      },
    },
  ];

  return (
    <Flex h="100%" w="100%">
      <Box className="border ag-theme-alpine" h="100%" p="xs" style={{ overflow: "auto" }} w="100%">
        <VSpace />
        <AgGridReact rowData={devices} columnDefs={columns} masterDetail={true} />
      </Box>
    </Flex>
  );
};

export default ArkSingleRoomValidationTable;
